declare global {
  interface Window {
    flutter_inappwebview?: {
      callHandler<T>(handlerName: string, ...args: unknown[]): Promise<T>;
    };
  }
}

export {};
